import { render, staticRenderFns } from "./ManageProduct.vue?vue&type=template&id=0bf03276&scoped=true"
import script from "./ManageProduct.vue?vue&type=script&lang=js"
export * from "./ManageProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf03276",
  null
  
)

export default component.exports